import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";

import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const useStyles = makeThemedStyles("CollapseCard", (theme) => ({
  root: {
    width: "100%",
    boxShadow: "none",
    "&::before": {
      opacity: 0,
    },
  },
  label: {
    textAlign: "center",
    width: "100%",
    color: "rgba(63, 69, 79, 0.7)",
  },
  detailsContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "3px",
  },
}));
type Props = {
  title: string;
  isOpen?: boolean;
};

const CollapseCard = (props: React.PropsWithChildren<Props>) => {
  const classes = useStyles();

  return (
    <Accordion classes={classes} expanded={props.isOpen}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-label="Expand"
        aria-controls="additional-actions1-content"
        id="additional-actions1-header"
      >
        <Typography variant="h5" className={classes.label}>
          {props.title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.detailsContainer}>
        {props.children}
      </AccordionDetails>
    </Accordion>
  );
};

export default CollapseCard;
